<div class="resizer">

  <div class="resizer-overlay" [ngStyle]="styles" #overlay>
    <div class="resizer-background"></div>
    <div class="resizer-corner resizer-corner-tl"></div>
    <div class="resizer-corner resizer-corner-tr"></div>
    <div class="resizer-corner resizer-corner-bl"></div>
    <div
      class="resizer-corner resizer-corner-br"
      (mousedown)="startResizing($event)"
    ></div>
    <div class="resizer-info">
      {{ resizableElement?.clientWidth || 0 }} x
      {{ resizableElement?.clientHeight || 0 }}
    </div>
  </div>

  <div class="styles-bar">
    <div class="btn-group field has-addons">
      <button
        type="button"
        class="button is-small"
        (click)="setResizableStyle({ width: '100%', display: 'block' })"
      >
        100%
      </button>
      <button
        type="button"
        class="button is-small"
        (click)="setResizableStyle({ width: '50%', display: 'block' })"
      >
        50%
      </button>
      <button
        type="button"
        class="button is-small"
        (click)="setResizableStyle({ width: '25%', display: 'block' })"
      >
        25%
      </button>
    </div>

    <div class="btn-group field has-addons">
      <button
        type="button"
        class="button is-small"
        (click)="setResizableStyle({ float: 'left' })"
      >
        <i class="fa fa-align-left"></i>
      </button>
      <button
        type="button"
        class="button is-small"
        (click)="
          setResizableStyle({
            float: 'none',
            display: 'block',
            margin: '0 auto'
          })
        "
      >
        <i class="fa fa-align-center"></i>
      </button>
      <button
        type="button"
        class="button is-small"
        (click)="setResizableStyle({ float: 'right' })"
      >
        <i class="fa fa-align-right"></i>
      </button>
    </div>

    <div class="btn-group field has-addons">
      <button
        type="button"
        class="button is-small"
        title="Trash"
        (click)="trashResizable()"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>
</div>
